import configureStoreDev from './configureStore.dev';
import configureStoreProd from './configureStore.prod';
var store = process.env.NODE_ENV === 'production'
    ? configureStoreProd
    : configureStoreDev;
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/store/configureStore.ts
// module id = 267
// module chunks = 50